// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PPushpinStopOutlinedSvg from "@fishx/icons-svg/es/asn/PPushpinStopOutlined";
import FishxIcon from '../components/FishxIcon';

var PPushpinStopOutlined = function PPushpinStopOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PPushpinStopOutlinedSvg
  }));
};

PPushpinStopOutlined.displayName = 'PPushpinStopOutlined';
export default React.forwardRef(PPushpinStopOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PPushpinStopOutlined.js
// module id = 3557
// module chunks = 0